import { render } from "./menu-item.vue?vue&type=template&id=56aa5146"
import script from "./menu-item.vue?vue&type=script&lang=js"
export * from "./menu-item.vue?vue&type=script&lang=js"

import "./menu-item.vue?vue&type=style&index=0&id=56aa5146&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-footer/menu-item.vue'],['render',render],['__file',"menu-item.vue"]])

export default __exports__